import { render, staticRenderFns } from "./FatturazioneNumeratoriEdit.vue?vue&type=template&id=239f1b84"
import script from "./FatturazioneNumeratoriEdit.vue?vue&type=script&lang=js"
export * from "./FatturazioneNumeratoriEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports